import "./notAuthorized.css";
import React from "react";
import { useNavigate } from "react-router-dom";

function NotAuthorized() {
	const navigate = useNavigate();

	const handleRefresh = () => {
		navigate("/");
	};

	return (
		<>
			<div className="unauthorized-page">
				<h1>
					4
					<lord-icon
						src="https://cdn.lordicon.com/vacmyjrh.json"
						trigger="loop"
						delay="2000"
						colors="primary:#fff"
						style={{ width: "130px", height: "130px" }}
					></lord-icon>
					3
				</h1>
				<h4 className="unauthorized-page-text">
					You are not authorized to access this route
				</h4>
				<button className="go-back-home-btn" onClick={handleRefresh}>
					Back to Login
				</button>
			</div>
		</>
	);
}

export default NotAuthorized;
